export default "__VITE_ASSET__CRcNNKqk__"